var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selo)?_c('validacao-selo'):_c('painel',{attrs:{"validacao":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }